/** Defines the global toast notification context. */
import { createContext } from 'react';

export const ToastContext = createContext(null);
